// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlay-module--overlay--2NL7M","container":"overlay-module--container--1kZb-","closeBtn":"overlay-module--closeBtn--NLlMA"};